import React from "react";
import { useQuery } from "@apollo/client";
import { loader } from "graphql.macro";
import { Storage } from "../util/storage";
import Loading from "./Loaders/Loading";
import ByIngredients from "./RecipeView/ByIngredients";

const GET_RECIPES = loader("../queries/by-ingredients.graphql");
const db = new Storage("ingredients");

export default function RecipeSuggestions() {
	const ingredients = db.getAllItems();
	const { loading, error, data } = useQuery(GET_RECIPES, {
		variables: { ingredients },
	});

	if (loading) {
		return <Loading />;
	}

	if (error) {
		return error;
	}

	const recipes = data?.search?.hits?.map((el) => el._source) || [];

	return (
		<div>
			{recipes.map((recipe, i) => {
				return (
					<ByIngredients recipe={recipe} ingredients={ingredients} key={i} />
				);
			})}
		</div>
	);
}
